
import { Container } from "react-bootstrap";
import ReactPlayer from "react-player";
import "../Home_css/story.css";
import "bootstrap/dist/css/bootstrap.css";
import story from "../../Assets/Dahlia_events/DHWebWelcome.mp4";

const OurStory = () => {
  return (
    <section id="About"  >
    <div
      className="d-flex justify-content-evenly align-items-center text-center"
      style={{ minHeight: "100vh"  }}
    >
      <Container  className="py-5">
     
        {/* Use justify-content-evenly to space the items within the section */}
        <div
          className="Ourstory d-flex flex-column align-items-center justify-content-evenly"
          style={{ minHeight: "70vh" }}
        >
              
          <div
            className="col-md-8 col-12 text-center d-flex flex-md-row flex-column align-items-center"
            style={{ gap: "40px" }}
          >
            <h1>
              Our <br /> Story
            </h1>
            <div>
              <h5>THE DAHLIA HEALTH DIFFERENCE</h5>
              <p>
                We are a team of professionals dedicated to achieving remarkable
                outcomes with a profound understanding of light physics, its
                biomedical impact on cells, and the optimization of treatments for
                maximum results.
              </p>
            </div>
          </div>
          <div className="col-md-8 col-12 mt-1 mb-5">
            <ReactPlayer
              url={story}
              controls
              width="100%"
              height="100%"
              config={{
                file: {
                  tracks: [
                    {
                      kind: "captions",
                      srcLang: "en",
                      label: "English",
                      default: true,
                    },
                  ],
                },
              }}
            />
          </div>
        </div>
      
      </Container>
    </div>
  </section>
  
  );
};

export default OurStory;






